import { IDynamicSubmitFieldProps } from "@view/common/DynamicForm/DynamicFormContracts";
import styles from "./OtpSlide.module.css";
import Button from "@view/common/Components/Button";

export interface ILoginSubmitFieldWithBackProps extends IDynamicSubmitFieldProps {
}

const OtpSumbit = (props: ILoginSubmitFieldWithBackProps) => {
  return (
    <div className={styles.submitRoot}>
      <Button
        className={styles.submitButton}
        variant="primary"
        type="button"
        disabled={props.disabled}
        onClick={props.onSubmit}
        loading={props.loading}
      >
        {props.label}
      </Button>
    </div>
  );
};

export default OtpSumbit;
